import React from 'react';
import { StyledCarouselHomeNew } from './StyledCarouselHomeNew';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

SwiperCore.use([Navigation]);


const CarouselHomeNew = ({  }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  return (
    <React.Fragment>
      {
       
          <StyledCarouselHomeNew>
            <div className="paragraph--col-wrap">
              <div className="paragraph--col-big">
                <h5 className="big--title">
                Discover the products that will add another dimension to the shopping experience
                </h5>
              </div>
              
            </div>
            <Swiper 
              
              spaceBetween={0}
              className="carousel-home--slider"
              navigation
              onReachEnd={(swiper) => swiper.snapGrid = [...swiper.slidesGrid]}
              breakpoints={{
                320: {
                  
                  slidesPerView: 2,
                },
                1024: {
                    
                    slidesPerView: 3,
                  },
              }}
              >
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">3D e-commerce</h6>
                    <p className="preset-11 paragraph--slide">Our solution to help you transform your e-commerce site into an engaging and interactive 3D shopping experience.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/products/3d-e-commerce')}>
                      <p className="preset-10 primary-green cursor-cta">Discover</p>
                      <img className="next  cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  
                  
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">Virtual Showroom</h6>
                    <p className="preset-11 paragraph--slide">Design the retail space your customers deserve by creating a fully immersive and custom VR experience.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/virtual-showroom')}>
                      <p className="preset-10 primary-green  cursor-cta">Discover</p>
                      <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text--slide">
                    <h6 className="big--title">Shelfzone</h6>
                    <p className="preset-11 paragraph--slide">The most sophisticated VR-ready SaaS retail simulation software.</p>
                    <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick('/shelfzone')}>
                      <p className="preset-10 primary-green  cursor-cta">Discover</p>
                      <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                    </div>
                  </div>
                  
                </SwiperSlide>
               
              
            </Swiper>
            
          </StyledCarouselHomeNew>
          
      }
    </React.Fragment>
  );
};

CarouselHomeNew.propTypes = {};

CarouselHomeNew.defaultProps = {
  tag: "div",
  bgColor: "#fff"
};

export default CarouselHomeNew;
